import { Link } from "react-router-dom";
import useStyles from "./styles";

function Footer() {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      &copy; Cosmos Offer Club {new Date().getFullYear()}&nbsp;|&nbsp;
      <Link className={classes.link} to="/privacypolicy">
        Privacy Policy
      </Link>
    </footer>
  );
}

export default Footer;
